import React from 'react';
import styled from 'styled-components';
import { CopyToClipboard } from '../../../../common/CopyToClipboard';

const CopyButton = styled.div`
    width: 3rem;
    height: 2rem;

    &:hover {
        &:after {
            background: rgba(0, 0, 0, .05);
        }
    }

    &:active {
        &:after {
            background: rgba(0, 0, 0, .1);
        }
    }

    &:after {
        content: 'Copy';
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
`;

export const InputCopyButton = React.memo(({ value }: { value: string }) => {
    return <CopyToClipboard value={value}>
        <CopyButton />
    </CopyToClipboard>;
});
